import React from 'react';
import { useTranslations } from '@components/context';

const SMSForm = ({ onCancel, config, className, mode, data }) => {
  const { t } = useTranslations();
  const datePickerRef = React.useRef();
  const lang = $("body").attr("lang");
  const hashIds = mode === "mass" ? tableSelection.currentlySelected() : null;
  const [message, setMessage] = React.useState("");
  const [recipients, setRecipients] = React.useState("");
  const [time, setTime] = React.useState("");
  const [recipientDTO, setRecipientDTO] = React.useState();
  const [senderDTO, setSenderDTO] = React.useState();
  const MAX_LENGTH = 500;
  const SHOW_CHAR_COUNTER_THRESHOLD = 320;
  const NUM_OF_ROWS = 10;

  const initDatePicker = () => {
    $(datePickerRef.current).datetimepicker({
      minDate: new Date(),
      dateFormat: "yy-mm-dd",
      timeFormat: "HH:mm",
      controlType: "select",
      oneLine: true,
      onSelect: (dateText) => {
        setTime(dateText ? in_utc(dateText) : "");
      },
    });
  };

  const getSelectedContacts = () => {
    const parameters = { hash_ids: hashIds };
    $.post(config.contacts.post.uri, parameters, function (data) {
      setRecipients(data.telephones);
    });
  };

  const getApplicationDetails = () => {
    $.get({ url: config.detail.get.uri, headers: config.detail.get.headers }, function (data) {
      const {
        message: { recipients, senders },
      } = data;
      setRecipientDTO(recipients[0].urn);
      setSenderDTO(senders[0].urn);
    }).fail(function (data) {
      notification(data.responseJSON.notification, { type: 'error' });
    });
  };

  const submitSMS = async () => {
    var savingIndicator = window.showSavingIndicator();
    let data = {
      language: lang,
      message: {
        sender: senderDTO || "-",
        recipient: recipientDTO || "-",
        body: message,
      },
    };
    if (time)
      data.message.sending_time = time;
    if (mode === "mass")
      data.hash_ids = hashIds;
    $.post({
      url: config.sms.post.uri,
      headers: config.sms.post.headers,
      data: JSON.stringify(data),
    })
      .done(savingIndicator, (data) => {
        onCancel();
        data && notification(data.notification, { type: 'success' });
        mode === "mass" && selectionConfirmation.showOverlay(hashIds.length, data);
      })
      .fail(savingIndicator, function (data) {
        data && notification(data.responseJSON.notification || data.responseJSON.title, { type: 'error' });
      });
  };

  React.useEffect(() => {
    mode === "mass" ? getSelectedContacts() : getApplicationDetails();
    initDatePicker();
  }, []);

  const isDisabled = () => {
    return !((mode === "mass" && message && recipients) || (mode === "single" && message && data && data.phoneNumber));
  };

  return (
    <form
      autoComplete="off"
      onSubmit={(e) => {
        e.preventDefault();
        submitSMS();
      }}
      className={className || ""}
    >
      <div className="overlay">
        {mode === "mass" &&
          <div className="overlay-header">
            <h3>{t("Send SMS")}</h3>
          </div>
        }
        <div className="overlay-main">
          <div className="form-group">
            <label className="control-label">{t("Recipients")}</label>
            <input
              type="text"
              readOnly
              disabled
              name="recipients"
              className="form-control"
              value={data ? data.phoneNumber : recipients}
            />
          </div>
          <div className="form-group">
            <label className="control-label">{t("Message")}</label>
            <textarea
              name="message"
              className="form-control"
              id="sms-overlay-textarea"
              value={message}
              onChange={({ target }) => setMessage(target.value)}
              rows={NUM_OF_ROWS}
              maxLength={MAX_LENGTH}
            ></textarea>
            {message.length > SHOW_CHAR_COUNTER_THRESHOLD && <p className="no-spacing-bottom spacing-top-s text-right text-grey">{message.length} / {MAX_LENGTH}</p>}
          </div>
          <div className="form-group">
            <label className="control-label">{t("Schedule message")}</label>
            <input
              ref={datePickerRef}
              readOnly
              type="text"
              name="time"
              onChange={({ target }) => setTime(target.value)}
              className="form-control message-datetime-display"
              placeholder={t("Date and time")}
            />
          </div>
        </div>
        <div className={ mode === "mass" ? "overlay-footer" : "text-right padding-vertical-10px"}>
          <div className="btn-container">
            {mode === "mass" && (
              <a className="btn btn-link overlay-cancel">{t('Cancel')}</a>
            )}
            <input className="btn btn-primary" type="submit" value={t("Send SMS")} disabled={isDisabled()} />
          </div>
        </div>
      </div>
    </form>
  );
};

export { SMSForm };

window.SMSForm = SMSForm;

export default SMSForm;
